module.exports = __webpack_public_path__ + "img/theplaylist.e232fcc4.jpg";